var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-medium is-primary"},[_c('div',{staticClass:"hero-body"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('p',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subtitulo)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }